import React from 'react';

function CheckboxInput(props) {
  return (
    <span>
      <input type="checkbox" id={props.checkboxName} name={props.checkboxName} {...props.input} />
      <label htmlFor={props.checkboxName}><span /><p>{ props.label }</p></label>
      { props.img && <img alt={props.id} src={props.img} /> }
      { props.meta.touched && props.meta.error && <p className="small error">{ props.meta.error }</p> }
    </span>
  );
}

CheckboxInput.propTypes = {
  input: React.PropTypes.object,
  meta: React.PropTypes.object,
};

export default CheckboxInput;



/** WEBPACK FOOTER **
 ** ./src/components/form-input-checkbox/index.js
 **/